<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Download Proposta</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-5 container mx-auto">
    @if (!loading) {
      <div class="flex flex-col items-center gap-4">
        <button
          mat-flat-button
          class="btn-tg w-5/12"
          (click)="downloadExcel()"
          [disabled]="loading"
        >
          <mat-icon>text_snippet</mat-icon> Excel
        </button>
        <button
          mat-flat-button
          class="btn-tg w-5/12"
          (click)="downloadPdf()"
          [disabled]="loading"
        >
          <mat-icon>picture_as_pdf</mat-icon> PDF
        </button>
      </div>
    } @else {
      <mat-divider></mat-divider>
      <div class="flex flex-col items-center gap-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <h3>
          Aguarde!<br />
          Arquivo sendo gerado!
        </h3>
      </div>
    }
  </div>
</mat-card>
